module.exports = __webpack_public_path__ + "media/images/LED-icon-yellow-9d6688d402fb2dd1e38f93372914577a.svg";